import script from "./Dot.vue?vue&type=script&setup=true&lang=js"
export * from "./Dot.vue?vue&type=script&setup=true&lang=js"

import "./Dot.vue?vue&type=style&index=0&id=4625776f&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4625776f"]])

export default __exports__